import { convert, stringToCode } from 'encoding-japanese'

import { toCsv } from '@/utils/csv/csv'

/**
 * 行の配列を、取り込んだ CSV と同じ文字コードの CSV の中身（Blob）にする（#5697・#5737）。
 * 切り出した行をそのまま直して取り込み直せるように、Shift_JIS・EUC-JP の CSV はその文字コードで書き出す。
 * それ以外（UTF-8・ASCII）は UTF-8 で、Excel で文字化けしないよう BOM を付ける（既存の CSV 書き出しと同じ）。
 */
export const csvRowsToBlob = (
  rows: string[][],
  /** 取り込みに使った文字コード（ParsedCsv.encodingCode、encoding-japanese の識別子） */
  encodingCode: string
): Blob => {
  const text = toCsv(rows)
  return encodingCode === 'SJIS' || encodingCode === 'EUCJP'
    ? new Blob(
        [
          new Uint8Array(
            convert(stringToCode(text), {
              to: encodingCode,
              from: 'UNICODE'
            })
          )
        ],
        {
          type: `text/csv;charset=${encodingCode === 'SJIS' ? 'shift_jis' : 'euc-jp'};`
        }
      )
    : new Blob(['\uFEFF' + text], { type: 'text/csv;charset=utf-8;' })
}

/** 行の配列を CSV のファイルにする（取込履歴に残すためにアップロードする、#5737） */
export const csvRowsToFile = (
  filename: string,
  rows: string[][],
  encodingCode: string
): File => {
  const blob = csvRowsToBlob(rows, encodingCode)
  return new File([blob], filename, { type: 'text/csv' })
}

/** 行の配列を CSV にして、取り込んだ CSV と同じ文字コードでダウンロードさせる（#5697） */
export const downloadCsvRows = (
  filename: string,
  rows: string[][],
  encodingCode: string
): void => {
  const url = URL.createObjectURL(csvRowsToBlob(rows, encodingCode))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
